export const createSurveyColors = () => {
  return [
    "rgb(252 103 113)",
    "rgb(255 158 107)",
    "rgb(249 188 107)",
    "rgb(208 228 114)",
    "rgb(75 187 138)",
  ];
};

export const createSurveyIcons = () => {
  const colors = createSurveyColors();
  return [
    {
      icon_name: "Star",
      type: "star",
      html:
        `<div class="survey-star"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" width="100%" height="100%"><path stroke="rgba(0, 0, 0, .5)" fill="#f5da56" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.55" d="M12.854 3.5a.979.979 0 0 0-1.708 0a26.978 26.978 0 0 0-2.057 4.762c-.139.431-.551.73-1.023.743a29.398 29.398 0 0 0-4.267.425c-.774.136-1.065 1.018-.515 1.556a31.484 31.484 0 0 0 3.41 2.892c.367.269.518.73.378 1.152a26.807 26.807 0 0 0-1.14 4.927c-.1.755.708 1.288 1.41.928a28.593 28.593 0 0 0 3.98-2.472a1.148 1.148 0 0 1 1.356 0a28.505 28.505 0 0 0 3.98 2.472c.701.36 1.51-.173 1.41-.928a26.81 26.81 0 0 0-1.14-4.928c-.14-.42.01-.882.378-1.151a31.497 31.497 0 0 0 3.41-2.892c.55-.538.26-1.42-.515-1.556a29.046 29.046 0 0 0-4.267-.425a1.097 1.097 0 0 1-1.023-.743a26.982 26.982 0 0 0-2.057-4.761"></path></svg></div>`,
    },
    {
      icon_name: "Thumb down",
      type: "thumb",
      html: `<div class="survey-thumb">
        <svg viewBox="0 0 24 24" fill="${
        colors[0]
      }" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.99997 4H17.1919C17.9865 4 18.7058 4.47039 19.0243 5.19836L21.8323 11.6167C21.9429 11.8695 22 12.1424 22 12.4184V13C22 14.1046 21.1045 15 20 15H13.5L14.7066 19.4243C14.8772 20.0498 14.5826 20.7087 14.0027 20.9986C13.4204 21.2898 12.7134 21.1274 12.3164 20.6114L8.41472 15.5392C8.14579 15.1896 7.99997 14.7608 7.99997 14.3198V14M7.99997 4H3C2.44772 4 2 4.44772 2 5V13C2 13.5523 2.44772 14 3 14H7.99997M7.99997 4V14" stroke="rgba(0, 0, 0, .5)" stroke-linecap="round" stroke-width="0.55" stroke-linejoin="round"/>
        </svg></div>
        `,
    },
    {
      icon_name: "Thumb up",
      type: "thumb",
      html: `
        <div class="survey-thumb">
        <svg viewBox="0 0 24 24" fill="
        ${colors[4]}" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.99997 20H17.1919C17.9865 20 18.7058 19.5296 19.0243 18.8016L21.8323 12.3833C21.9429 12.1305 22 11.8576 22 11.5816V11C22 9.89544 21.1045 9.00001 20 9.00001H13.5L14.7066 4.57571C14.8772 3.95024 14.5826 3.29131 14.0027 3.00137C13.4204 2.71021 12.7134 2.87257 12.3164 3.38861L8.41472 8.46083C8.14579 8.81045 7.99997 9.23916 7.99997 9.68025V20ZM7.99997 20H3C2.44772 20 2 19.5523 2 19V11C2 10.4477 2.44772 10 3 10H7.99997V20Z" stroke="rgba(0, 0, 0, .5)" stroke-linecap="round" stroke-width="0.55" stroke-linejoin="round"/>
        </svg>
        </div>
      `,
    },
  ];
};
